module.exports = __webpack_public_path__ + "img/5.67ec1b3e.png";